"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReRenderSubscription = void 0;
const react_1 = require("react");
exports.useReRenderSubscription = (subscription) => {
    const forceUpdate = useForceUpdate();
    react_1.useEffect(() => {
        return subscription.subscribe(forceUpdate);
    }, []);
};
const useForceUpdate = () => {
    const [, forceUpdate] = react_1.useReducer(x => x + 1, 0);
    return forceUpdate;
};
